import { FilterConfig, useFiltering } from "hooks/useFiltering";
import { FeatureRequest } from "interfaces/feature-request";
import React from "react";
import FeatureRequestsControls from "./FeatureRequestsControls";
import FeatureRequestsTable from "./FeatureRequestsTable";
import { Container, Header } from "./components/generic";

const filterConfig: { [key: string]: FilterConfig<FeatureRequest> } = {
    search: { fields: ["id", "name", "description"], type: "string" },
    state: { fields: ["state"], type: "exact" },
};

interface FeatureRequestsListProps {
    featureRequests: FeatureRequest[];
    visible: boolean;
}

const FeatureRequestsList: React.FC<FeatureRequestsListProps> = ({ featureRequests, visible }) => {
    const { filteredData, getFilterValue, setFilterValue } = useFiltering<FeatureRequest>(
        featureRequests,
        filterConfig
    );

    return visible ? (
        <>
            <Header>Kehitysehdotukset</Header>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae sapien ornare,
                consequat libero id, porta velit. Suspendisse interdum urna non dolor pretium
                ornare. Aliquam vitae ex commodo, iaculis dui suscipit, fringilla tellus. Duis
                viverra porttitor convallis. Aenean sodales justo sit amet urna dignissim, eu
                lobortis ante mollis. Proin eget massa non mi consequat vehicula. Mauris eget lacus
                interdum, euismod ipsum eget, placerat metus. Nam euismod sapien felis, eget pretium
                augue bibendum vel.
            </p>
            <Container>
                <FeatureRequestsControls
                    getFilterValue={getFilterValue}
                    setFilterValue={setFilterValue}
                />
                <FeatureRequestsTable featureRequests={filteredData} />
            </Container>
        </>
    ) : null;
};

export default FeatureRequestsList;
